import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import LeadDetail from './pages/LeadDetail';
import Accounts from './pages/Accounts';
import AccountDetail from './pages/AccountDetail';
import Contacts from './pages/Contacts';
import Insights from './pages/Insights';
import Tasks from './pages/Tasks';
import Activities from './pages/Activities';
import StrategyCreativeDashboard from './pages/StrategyCreativeDashboard';
import DeliveryDashboard from './pages/DeliveryDashboard';
import RecycleBin from './pages/RecycleBin';
import Export from './pages/Export';
import Import from './pages/Import';
import ClosePlans from './pages/ClosePlans';
import Billing from './pages/Billing';
import Admin from './pages/Admin';
import Tags from './pages/Tags';
import CustomFields from './pages/CustomFields';
import Notifications from './pages/Notifications';
import Files from './pages/Files';
import StageMovements from './pages/StageMovements';
import Webhooks from './pages/Webhooks';
import MeetingAnalytics from './pages/MeetingAnalytics';
import Settings from './pages/Settings';
import TeamView from './pages/TeamView';
// import ServicesCatalog from './pages/ServicesCatalog'; // Removed - not required

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Router>
          <Routes>
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/leads"
              element={
                <ProtectedRoute>
                  <Leads />
                </ProtectedRoute>
              }
            />
            <Route
              path="/leads/:id"
              element={
                <ProtectedRoute>
                  <LeadDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/accounts"
              element={
                <ProtectedRoute>
                  <Accounts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/accounts/:id"
              element={
                <ProtectedRoute>
                  <AccountDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts"
              element={
                <ProtectedRoute>
                  <Contacts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tasks"
              element={
                <ProtectedRoute>
                  <Tasks />
                </ProtectedRoute>
              }
            />
            <Route
              path="/activities"
              element={
                <ProtectedRoute>
                  <Activities />
                </ProtectedRoute>
              }
            />
            <Route
              path="/insights"
              element={
                <ProtectedRoute>
                  <Insights />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/strategy-creative"
              element={
                <ProtectedRoute>
                  <StrategyCreativeDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/delivery"
              element={
                <ProtectedRoute>
                  <DeliveryDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/auth/callback" element={<Login />} />
            <Route
              path="/recycle-bin"
              element={
                <ProtectedRoute>
                  <RecycleBin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/export"
              element={
                <ProtectedRoute>
                  <Export />
                </ProtectedRoute>
              }
            />
            <Route
              path="/import"
              element={
                <ProtectedRoute>
                  <Import />
                </ProtectedRoute>
              }
            />
            <Route
              path="/close-plans"
              element={
                <ProtectedRoute>
                  <ClosePlans />
                </ProtectedRoute>
              }
            />
            <Route
              path="/billing"
              element={
                <ProtectedRoute>
                  <Billing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tags"
              element={
                <ProtectedRoute>
                  <Tags />
                </ProtectedRoute>
              }
            />
            <Route
              path="/custom-fields"
              element={
                <ProtectedRoute>
                  <CustomFields />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notifications"
              element={
                <ProtectedRoute>
                  <Notifications />
                </ProtectedRoute>
              }
            />
            <Route
              path="/files"
              element={
                <ProtectedRoute>
                  <Files />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stage-movements"
              element={
                <ProtectedRoute>
                  <StageMovements />
                </ProtectedRoute>
              }
            />
            <Route
              path="/webhooks"
              element={
                <ProtectedRoute>
                  <Webhooks />
                </ProtectedRoute>
              }
            />
            <Route
              path="/meeting-analytics"
              element={
                <ProtectedRoute>
                  <MeetingAnalytics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team-view"
              element={
                <ProtectedRoute>
                  <TeamView />
                </ProtectedRoute>
              }
            />
            {/* Services Catalog removed - not required */}
            <Route path="/auth/callback" element={<Login />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          </Router>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
